import { render, staticRenderFns } from "./DataTableContacts.vue?vue&type=template&id=6e0a80b8&scoped=true&"
import script from "./DataTableContacts.vue?vue&type=script&lang=js&"
export * from "./DataTableContacts.vue?vue&type=script&lang=js&"
import style0 from "./DataTableContacts.vue?vue&type=style&index=0&id=6e0a80b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a80b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VExpandTransition,VFlex,VIcon,VLayout,VSheet,VSpacer,VTooltip})
